import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { gql } from 'graphql-request'

import { useGraphQLClient } from '@/hooks/useGraphQLClient'

const UPDATE_USER_MUTATION = gql`
  mutation updateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        phoneNumber
      }
      success
      errors {
        field
        message
      }
    }
  }
`

export interface UpdateUserInput {
  firstName: string
  lastName: string
  email: string
  countryCode: string
  phoneNumber: string
  terms: boolean
  smsTrackingOptinConfirmed: boolean
  hearAboutUs: string
}

interface UpdateUserMutation {
  user: User
  success: boolean
  errors: MutationError[]
}

interface UpdateUserMutationResponse {
  updateUser: UpdateUserMutation
}

export const useUpdateUserApi = (): UseMutationResult<
  UpdateUserMutation,
  Error,
  UpdateUserInput,
  unknown
> => {
  const client = useGraphQLClient()

  const updateUserApi = async (input: UpdateUserInput): Promise<UpdateUserMutation> => {
    const result = await client.request<UpdateUserMutationResponse>(UPDATE_USER_MUTATION, { input })

    return result.updateUser
  }

  return useMutation<UpdateUserMutation, Error, UpdateUserInput>({
    mutationFn: updateUserApi,
  })
}

export default useUpdateUserApi
